module.exports = __webpack_public_path__ + "static/media/IMG-20201016-WA0031.d5e67304.jpg";